import { Button } from '@journ/ui/button'
import { Icons } from '@journ/ui/icons'
import { useIntlayer } from 'react-intlayer'
import type { ApprovalStage, TimeOffType } from '../domain/timeoff'
import { useMemberParams } from './use-member-params'

const STAGE_KEYS: ApprovalStage[] = ['pending_dept', 'pending_hr', 'approved', 'rejected']
const TYPE_KEYS: TimeOffType[] = ['vacation', 'sick_leave', 'unpaid_leave', 'parental_leave', 'other']

const TimeOffFilterList = () => {
	const content = useIntlayer('hr-page')
	const to = content.timeOff
	const { toStage, toType, setParams } = useMemberParams()

	const chips: Array<{ key: string; label: string; onRemove: () => void }> = []

	const stage = STAGE_KEYS.find(s => s === toStage)
	if (stage) {
		chips.push({
			key: `stage:${stage}`,
			label: to.stage[stage]?.value ?? stage,
			onRemove: () => setParams({ toStage: null }),
		})
	}

	const type = TYPE_KEYS.find(t => t === toType)
	if (type) {
		chips.push({
			key: `type:${type}`,
			label: to.requestType[type]?.value ?? type,
			onRemove: () => setParams({ toType: null }),
		})
	}

	if (!chips.length) return null

	return (
		<ul className='flex space-x-2'>
			{chips.map(chip => (
				<li key={chip.key}>
					<Button
						className='h-9 px-2 bg-secondary hover:bg-secondary font-normal text-muted-foreground flex space-x-1 items-center group rounded-none'
						onClick={chip.onRemove}
					>
						<Icons.Clear className='scale-0 group-hover:scale-100 transition-all w-0 group-hover:w-4' />
						<span>{chip.label}</span>
					</Button>
				</li>
			))}
		</ul>
	)
}

export { TimeOffFilterList }
